import Page from './Page';


const ReportTemplateApi = (function () {
    const internalGet = url => $.ajax({ type: 'GET', contentType: 'application/json', dataType: 'json', url: url, cache: false, async: true });
    const internalPost = (url, data) => $.ajax({ type: 'POST', contentType: 'application/json', dataType: 'json', url: url, data: JSON.stringify(data), cache: false, async: true });
    const internalDelete = (url) => $.ajax({ type: 'DELETE', contentType: 'application/json', dataType: 'json', url: url, cache: false, async: true });

    const internalGetTags = (id) => internalGet(Page.getApplicationPath() + 'api/v1/frontend/reporttemplate/' + id + '/tags');
    const internalPostTag = (id, data) => internalPost(Page.getApplicationPath() + 'api/v1/frontend/reporttemplate/' + id + '/tags', data);
    const internalDeleteTag = (id, tag) => internalDelete(Page.getApplicationPath() + 'api/v1/frontend/reporttemplate/' + id + '/tags/' + tag);

    return {
        getTagsPromise: internalGetTags,
        postTagPromise: internalPostTag,
        deleteTagPromise: internalDeleteTag
    };

})();

var ReportTemplateIds = {
    TagAreaSelector: "#TAGS",
    TagGridBodySelector: "#TagsGrid > tbody",
    ErrorMessageAlertSelector: "#ErrorMessageAlert",
    TagHiddenInputSelector: "#ReportTemplateTag",
    EditingTagTypeSelector: "#tipoTag > li.active",
    EditingGroupNameSelector: "#TxtGroupName",
    EditingAliasSelector: "#TxtTagName"
};

var ReportTemplateTags = (function () {

    const tagTypes = {
        "path": { TranslatorType: "", Selector: "#TxtCaminho" },
        "campo": { TranslatorType: "@CAMPO|", Selector: "#CmbCampo" },
        "sql": { TranslatorType: "@SQL|", Selector: "#TxtSql" },
        "tabela": { TranslatorType: "@TABELA|", Selector: "#TxtTabela" },
        "sistema": { TranslatorType: "@SISTEMA|", Selector: "#CmbSistema" }
    };

    const copyBtnHtml = '<a class="btn btn-xs btn-circle default" onclick="Benner.ReportTemplate.copyToClipboard(this);" title="Copiar para área de transferência"><i class="fa-duotone fa-copy fa-fw"></i></a>';

    var internalGetTagHtml = function (tag) {
        var html = '<tr data-name="' + tag.Alias + '">';
        html += '<td>' + tag.GroupName + '</td>';
        html += '<td>' + copyBtnHtml + '<span class="copyable">' + tag.Alias + '</span></td>';
        html += '<td>' + copyBtnHtml + '<span class="copyable">' + tag.Value + '</span></td>';
        html += '<td>';
        html += '<a title="' + BennerTranslations.edit + '" class="btn btn-xs btn-circle blue" onclick="Benner.ReportTemplate.editTag(this);return false;"><i class="fa-duotone fa-pen fa-fw"></i></a>';
        html += '<a title="' + BennerTranslations.delete + '" class="btn btn-xs btn-circle red" onclick="Benner.ReportTemplate.deleteTag(this);return false;"><i class="fa-duotone fa-trash-can fa-fw"></i></a>';
        html += '</td>';
        html += '</tr>';
        return html;
    };

    var internalRenderTags = function (tags) {
        var html = '';
        tags.forEach(function (tag) {
            html += internalGetTagHtml(tag);
        });

        var placeholder = $(ReportTemplateIds.TagGridBodySelector);
        $(placeholder).empty();
        $(placeholder).append(html);
        $(ReportTemplateIds.ErrorMessageAlertSelector).empty().hide();
    };

    var internalRenderError = function (message) {
        $(ReportTemplateIds.TagGridBodySelector).empty();

        var placeholder = $(ReportTemplateIds.ErrorMessageAlertSelector);
        $(placeholder).empty().text(message).show();
    };

    var internalGetEditingTag = function () {
        var tagType = $(ReportTemplateIds.EditingTagTypeSelector).data("tag-type");

        var value = "";
        var rawValue = $(tagTypes[tagType].Selector).val();
        if (rawValue) {
            value = tagTypes[tagType].TranslatorType + rawValue;
        }

        var tagData = {
            GroupName: $(ReportTemplateIds.EditingGroupNameSelector).val(),
            Alias: $(ReportTemplateIds.EditingAliasSelector).val(),
            Value: value
        };

        return tagData;
    };

    return {
        renderTags: internalRenderTags,
        renderError: internalRenderError,
        getEditingTag: internalGetEditingTag
    };
})();

var ReportTemplate = (function () {

    const blockUI = function () {
        App.blockUI({ animate: true });
    };

    const unblockUI = function () {
        App.unblockUI();
    };

    const getCurrentId = function () {
        // Página de formulário do relatório
        var id = "";
        Benner.Page.widgets.forEach(function (widget) {
            if (widget.id == "RELATORIO") {
                id = widget.field("HANDLE");
            }
        });

        if (id == "" && parent.Benner) {
            return parent.Benner.ReportTemplate.getId()
        }

        return id;
    };

    const internalSaveCurrentTag = function () {
        var payload = ReportTemplateTags.getEditingTag();

        if (payload.Alias.trim() == "" || payload.Value.trim() == "") {
            $(ReportTemplateIds.ErrorMessageAlertSelector).text("O nome e o valor da tag são obrigatórios.").show();
        } else {
            $(ReportTemplateIds.ErrorMessageAlertSelector).hide();
        }

        var id = getCurrentId();

        blockUI();
        ReportTemplateApi.postTagPromise(id, payload)
            .done(function (data) {
                toastr.success("Tag salva com sucesso.");
            }).fail(function (jqXHR, textStatus, errorThrown) {
                toastr.error(jqXHR.responseJSON.ExceptionMessage, "Erro ao salvar tag.");
                console.log(errorThrown);
                console.log(textStatus);
            }).always(function () {
                unblockUI();
            });
    };


    const getTagNameFromElement = function (anyElement) {
        var tr = $(anyElement).closest('tr');
        var name = $(tr).data("name");
        return name;
    }

    const internalOpenTagEditor = function (urlParams) {
        var url = Page.getApplicationPath() + "/SiteSettings/TemplateReport/TagEditor.aspx?reportTemplateId=" + getCurrentId() + "&imp=1";
        if (urlParams) {
            url += "&" + urlParams;
        }
        var onOpen = function () { };
        var onClose = function () { internalUpdate(); };
        Benner.ModalPage.show({ url: url, size: "large", title: "Adicionar tag", height: 500 }, onOpen, onClose);
    };

    const internalEditTag = function (anyElement) {
        var name = getTagNameFromElement(anyElement);
        var urlParams = "tagName=" + encodeURIComponent(name);
        internalOpenTagEditor(urlParams);
    };

    const internalDeleteTag = function (anyElement) {
        var id = getCurrentId();
        var name = getTagNameFromElement(anyElement);
        blockUI();
        ReportTemplateApi.deleteTagPromise(id, name)
            .done(function (data) {
                $(anyElement).closest('tr').fadeOut(200, function () { $(this).remove(); });
                toastr.success("Tag excluída com sucesso.");
            }).fail(function (jqXHR, textStatus, errorThrown) {
                toastr.error(jqXHR.responseJSON.ExceptionMessage, "Erro ao excluir tag.");
                console.log(errorThrown);
                console.log(textStatus);
            }).always(function () {
                unblockUI();
            });
    };

    const internalUpdate = function () {
        var id = getCurrentId();

        if (id == "" || id == "-1") {
            $("#TAGS").hide();
            return;
        } else {
            $("#TAGS").show();
        }

        blockUI();
        ReportTemplateApi.getTagsPromise(id)
            .done(function (data) {
                var content = data.content;
                ReportTemplateTags.renderTags(content);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                console.log(errorThrown);
                console.log(jqXHR.responseJSON.ExceptionMessage);
                ReportTemplateTags.renderError("Ocorreu um erro ao carregar as tags. Verifique o console para mais detalhes.");
            }).always(function () {
                unblockUI();
            });
    };

    const internalCopyToClipboard = function (anyElement) {
        var text = '{{' + $(anyElement).closest('td').find(".copyable").text().trim() + '}}';
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(text).select();
        document.execCommand("copy");
        $temp.remove();
        toastr.info("Texto copiado para a área de transferência.");
    };

    const internalInit = function () {
        internalUpdate();
        var prm = Sys.WebForms.PageRequestManager.getInstance();
        if (!prm.get_isInAsyncPostBack()) {
            prm.add_endRequest(function (sender, args) {
                internalUpdate();
            });
        };
    };

    return {
        init: internalInit,
        getId: getCurrentId,
        openTagEditor: internalOpenTagEditor,
        saveCurrentTag: internalSaveCurrentTag,
        editTag: internalEditTag,
        deleteTag: internalDeleteTag,
        copyToClipboard: internalCopyToClipboard
    };
})();

export default ReportTemplate;